module.exports = __webpack_public_path__ + "static/img/Textiles1.0f707a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Textiles1.jpg
// module id = tD8M
// module chunks = 1